// extracted by mini-css-extract-plugin
export default {"btn":"secondaryButton_btn__0Xn9FQHV","default":"secondaryButton_default__IkQI9CeZ","active":"secondaryButton_active__ZZaD42DF"};